export default {
    url: '/questions',
    template: '<forms-questions></forms-questions>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/questions/index.js